import React, { useContext } from 'react';
import { Table } from 'reactstrap';
import { LightAsync as SyntaxHighlighter } from 'react-syntax-highlighter';
import SeverityTag from '../../components/SeverityTag';
import { formatUtcDate } from '../../helpers/date-utils';
import { getDetailsUrl } from '../../helpers/get-details-url';
import { getKeyFormatted } from '../../helpers/text-utils';
import AxiosContext from '../../helpers/AxiosContext';

const IssuesTable = (props) => {
    const api_call = (useContext(AxiosContext)).axios;
    const type = props.type;
    const headers = props.headers || [];
    const issues = props.issues || [];
    const setEntry = props.setEntry || {};

    const getKeyValue = (key, value) => {
        if(!['id', 'generalIssueId'].includes(key)) {
            if (['diff', 'code_section'].includes(key)) {
                return <SyntaxHighlighter>{value}</SyntaxHighlighter>; //todo add language
            }
            if (key === 'recommendation') {
                return <div dangerouslySetInnerHTML={{ __html: value }} />;
            }
            if (key === 'severity') {
                return <SeverityTag value={value} />;
            }
            if (['entry_date', 'created', 'updated', 'last_found_at'].includes(key)) {
                return formatUtcDate(value);
            }
            /**
             * If the issue[header] is an object, it's stringuified
             *
             * Ex.: issue['general_issue']
             */
            if (typeof value == 'object') {
                return JSON.stringify(value);
            } else {
                return value;
            }
        } else {
            return '';
        }
    };

    const getDetails = async (object_id, generalIssueId) => {
        let res = await api_call.get(getDetailsUrl(type), { params: { object_id, generalIssueId } }).catch((e) => {
            console.error(e);
        });

        if (res) {
            setEntry(res.data);
        }
    };

    return (
        <Table borderless hover responsive striped>
            <thead>
                <tr>
                    {headers.map((head, idx) => {
                        if(!['id', 'generalIssueId'].includes(head)) {
                            return <td key={idx}>{getKeyFormatted(head)}</td>;
                        }
                        return <td key={idx}></td>;
                    })}
                </tr>
            </thead>
            <tbody>
                {issues.map((item, idx) => {
                    return (
                        <tr
                            key={idx}
                            data-testid={`issues-table-${idx}-row`}
                            onClick={() => {
                                getDetails(item.id, item.generalIssueId);
                            }}>
                            {/**
                                 * For each issue, we create a row on the table.
                                 * Then, we need to get the issue data and associate it
                                 * with the table headers, which is an array of string like so:
                                 *
                                 * ['repository', 'message', 'author', 'entry_date', 'general_issue']
                                 *
                                 * To do this association, we iterate the headers array and for each header
                                 * we get the issue value in which the key has the same name as the current header.
                                 *
                                 * Ex.: item['repository'], item['author']
                                 *
                                 *  Like this, we create datacells and complete the table fields
                                 */}
                            {headers.map((head, idy) => {
                                return <td key={idy} style={{'cursor': 'pointer'}}>{getKeyValue(head, item[head])}</td>;
                            })}
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
};

export default IssuesTable;
